/* mainConditionThunk.ts */

/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Utils */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

export const fetchMainConditions = createAsyncThunk<
  string[] | undefined
>("/options/main_conditions", async () => {
  try {
    const response = await axiosInterceptor.get<string[]>(
      "/options/main_conditions"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});
